import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Login from '../views/login/Login.vue'
import Register from '../views/Register.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    redirect: '/project',
    meta: {
      needLogin: true
    },
    children: [
      {
        path: '/project',
        name: 'project',
        component: () => import('@/components/project/prostatus.vue')
      },
      {
        path: '/material',
        name: 'material',
        component: () => import('@/components/project/material.vue')
      },
      {
        path: '/recycleBinPro',
        name: 'recycleBinPro',
        component: () => import('@/components/recycleBin/recycleBin.vue')
      },
      {
        path: '/recycleBinMat',
        name: 'recycleBinMat',
        component: () => import('@/components/recycleBin/recycleBinMaterial.vue')
      },
      {
        path: '/user',
        name: 'user',
        component: () => import('@/components/userInfo/userInfo.vue')
      },
      {
        path: '/cust',
        name: 'cust',
        component: () => import('@/components/customerService/custService.vue')
      },
      {
        path: '/order',
        name: 'order',
        component: () => import('@/components/order/order.vue')
      },
    ]
  },
  {
    path: '/Msg',
    name: 'Msg',
    component: () => import('@/components/systemMessages/systemMsg.vue')
  },
  {
    path: '/instruct',
    name: 'instruct',
    component: () => import('@/components/helpPages/instructions.vue'),
    hidden: true
  },
  {
    path: '/support',
    name: 'support',
    component: () => import('@/components/helpPages/technicalSupport.vue')
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/homePage',
    name: 'homePage',
    component: () => import('@/views/page/homePage.vue'),
    hidden: true
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      needLogin: false
    }
  },
  // {
  //   path:'/register',
  //   name: 'register',
  //   component: Register,
  //   meta:{
  //     needLogin:false
  //   }
  // },
]

// 白名单
const whiteList = ['/instruct', '/homePage'];
const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to, from, next) => {
  let token = localStorage.getItem('token');
  if (token || to.path === '/login'/* || to.path === '/register'*/) {
    next();
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login');
    }
  }
})
export default router
